/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './bed-allotment.reducer';

export const BedAllotmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bedAllotmentEntity = useAppSelector(state => state.bedAllotment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bedAllotmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bedAllotment.detail.title">BedAllotment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bedAllotment.id">Id</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentEntity.id}</dd>
          <dt>
            <span id="allotmentDate">
              <Translate contentKey="tinyMedicRestApp.bedAllotment.allotmentDate">Allotment Date</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentEntity.allotmentDate}</dd>
          <dt>
            <span id="releaseDate">
              <Translate contentKey="tinyMedicRestApp.bedAllotment.releaseDate">Release Date</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentEntity.releaseDate}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.bedAllotment.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bedAllotment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bedAllotment.active">Active</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="allotmentNotes">
              <Translate contentKey="tinyMedicRestApp.bedAllotment.allotmentNotes">Allotment Notes</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentEntity.allotmentNotes}</dd>
          <dt>
            <span id="allotmentType">
              <Translate contentKey="tinyMedicRestApp.bedAllotment.allotmentType">Allotment Type</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentEntity.allotmentType}</dd>
          <dt>
            <span id="releaseType">
              <Translate contentKey="tinyMedicRestApp.bedAllotment.releaseType">Release Type</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentEntity.releaseType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bedAllotment.bed">Bed</Translate>
          </dt>
          <dd>{bedAllotmentEntity.bed ? bedAllotmentEntity.bed.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bedAllotment.admission">Admission</Translate>
          </dt>
          <dd>{bedAllotmentEntity.admission ? bedAllotmentEntity.admission.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/bed-allotment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/bed-allotment/${bedAllotmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BedAllotmentDetail;
